import { Control } from "../Control";

export class LabeledControl extends Control {

    constructor(parent, params = {}) {

        params = Object.assign({
            text: null,
            control: null
        }, params || {});

        super(parent, params);

    };

    getText() {

        return (typeof this.text === 'function') ? this.text.call(this) : this.text;

    };

    getControl() {

        return (typeof this.control === 'function') ? this.control.call(this) : this.control;

    };

    _render(r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;

        var control = this.getControl(),
            renderedControl = (control && control.render(renderer, vm)) || null,
            props = {
                id: this.getId(),
                readonly: this.isReadOnly(),
                disabled: this.isDisabled(),
            },
            controlName = (control && control.getId && control.getId()) || null;

        return renderer.el('div', ['form-group', this.getCss()].filter(Boolean).join(' '), props, [
            renderer.el('label', null, { for: controlName }, this.getText()),
            renderedControl,
        ]);

    };

}